// extracted by mini-css-extract-plugin
export var searchHeader = "_3s-0";
export var searchHeaderDark = "_3s-1";